/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseGetAllStatusResponse,
} from '../models/index';
import {
    ResponseGetAllStatusResponseFromJSON,
    ResponseGetAllStatusResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class StatusApi extends runtime.BaseAPI {

    /**
     * ステータス一覧を取得
     * ステータス一覧を取得
     */
    async statusGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetAllStatusResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/status/getAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetAllStatusResponseFromJSON));
    }

    /**
     * ステータス一覧を取得
     * ステータス一覧を取得
     */
    async statusGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetAllStatusResponse>> {
        const response = await this.statusGetAllGetRaw(initOverrides);
        return await response.value();
    }

}
